import React from 'react';
import BaseComponent from './components/BaseComponent';
import './App.css'; 
import Swiper from './components/SwiperComponent';
import tuichu from './img/icons/tuichu.svg';

const imgs = [
  {
    id: '1',
    src: require('./img/banner2.jpg')
  }
]

class App extends BaseComponent {
  constructor(prop: any) {
    super(prop);
  }
  public Jump = (url: string)=> {
    this.props.history.push(url);
  }
  public JumpOther = (url: string) => {
    window.location.href = url;
  }
  public Logout = () => {
    localStorage.removeItem('userID');
    this.Jump('/Login');
  }
  public ShowInfo = () => {
    this.ShowToast('有声账号：wxtsg 密码：wxtsg', 2, 0, ()=>{
      this.RemoveToast();
    }, () => {
      this.RemoveToast();
    });
  }
  public render() {
    return (
      <div className="c-box">
        <div className="c-banner1">
          <Swiper data={imgs}/>
        </div>
        <div className="c-index-menu">
          <ul>
            {/* <li>
              <a>
                <div className="c-img"><img src={require("./img/img1.jpg")} /></div>
                <div className="c-tit">新书通报</div>
              </a>
            </li> */}
            {/* <li>
              <a onClick={this.Jump.bind(this, '/Main?type=2')}>
                <div className="c-img"><img src={require("./img/img2.jpg")} /></div>
                <div className="c-tit">有声读物</div>
              </a>
            </li> */}
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://data.360guoxue.com:525')}>
                <div className="c-img"><img src={require("./img/img2.jpg")} /></div>
                <div className="c-tit">少儿有声</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://data.360guoxue.com:527')}>
                <div className="c-img"><img src={require("./img/img2.jpg")} /></div>
                <div className="c-tit">公图有声</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://data.360guoxue.com:529')}>
                <div className="c-img"><img src={require("./img/img2.jpg")} /></div>
                <div className="c-tit">党政有声</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, '/Main?type=3')}>
                <div className="c-img"><img src={require("./img/img2.jpg")} /></div>
                <div className="c-tit">少儿绘本</div>
              </a>
            </li>
            {/* <li>
              <a onClick={this.ShowInfo}>
                <div className="c-img"><img src={Logout} /></div>
                <div className="c-tit">获取有声账号</div>
              </a>
            </li> */}
            <li>
              <a onClick={this.Jump.bind(this, '/Main?type=1')}>
                <div className="c-img"><img src={require("./img/img3.jpg")} /></div>
                <div className="c-tit">图书阅读</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://mc.m.5read.com/other/webapp4Video_webApp4Video_videoCataList2.jspx')}>
                <div className="c-img"><img src={require("./img/img4.jpg")} /></div>
                <div className="c-tit">视频观看</div>
              </a>
            </li>
            <li>
              <a>
                <div className="c-img"><img src={require("./img/img5.jpg")} /></div>
                <div className="c-tit">行知国学</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://www.libdiy.cn/wechat/index.html?libid=116')}>
                <div className="c-img"><img src={require("./img/img6.jpg")} /></div>
                <div className="c-tit">妙趣手工</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://wap.fzwjt.com/Home/Index')}>
                <div className="c-img"><img src={require("./img/img7.jpg")} /></div>
                <div className="c-tit">微讲堂</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://child.m.wsbgt.com/Home/Index')}>
                <div className="c-img"><img src={require("./img/img8.jpg")} /></div>
                <div className="c-tit">乐于学</div>
              </a>
            </li>
            <li>
              <a onClick={this.JumpOther.bind(this, 'http://lib.61read.com/')}>
                <div className="c-img"><img src={require("./img/img9.jpg")} /></div>
                <div className="c-tit">中年报刊</div>
              </a>
            </li>
            <li>
              <a onClick={this.Logout}>
                <div className="c-img"><img style={{width: '80%'}} src={tuichu} /></div>
                <div className="c-tit">退出登录</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default App;
